export default "__VITE_ASSET__DI2A6D21__"